import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyConfigUsage = loadable(() => import(/* webpackChunkName: "content/examples/config-usage" */ './ExampleConfigUsage'), 'ExampleConfigUsage');
